import type { ReactNode } from 'react'
import { Badge, Box, Text } from '@mantine/core'
import { DataTableScroll } from '@/components/ui'

export function displayNameUser(u: {
  first_name?: string | null
  last_name?: string | null
  email?: string | null
}) {
  const parts = [u.first_name, u.last_name].filter(Boolean) as string[]
  if (parts.length) return parts.join(' ')
  return u.email || 'Оператор'
}

export function TicketsStripHead({
  title,
  count,
  sub,
  statusSlot,
}: {
  title: string
  count: number
  sub?: boolean
  /** Индикатор статуса смены сотрудника — показывается справа от имени. */
  statusSlot?: ReactNode
}) {
  return (
    <Box
      className={sub ? 'tickets-strip-head tickets-strip-head--sub' : 'tickets-strip-head'}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 'var(--mantine-spacing-sm)',
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--mantine-spacing-xs)',
          flexWrap: 'wrap',
          minWidth: 0,
        }}
      >
        <Text
          component="span"
          fw={sub ? 600 : 700}
          fz={sub ? 'sm' : { base: 'sm', sm: 'md' }}
          className="tickets-strip-head__title"
        >
          {title}
        </Text>
        {statusSlot}
      </Box>
      <Badge size={sub ? 'sm' : 'md'} variant="light" color="gray">
        {count.toLocaleString('ru-RU')}
      </Badge>
    </Box>
  )
}

export function TicketsStripBlock({
  title,
  count,
  children,
  statusSlot,
}: {
  title: string
  count: number
  children: ReactNode
  statusSlot?: ReactNode
}) {
  return (
    <Box className="tickets-strip-block">
      <TicketsStripHead title={title} count={count} statusSlot={statusSlot} />
      <DataTableScroll className="tickets-table-scroll tickets-strip-table">{children}</DataTableScroll>
    </Box>
  )
}
